import * as Dropdown from "@radix-ui/react-dropdown-menu";
import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";

const CustomDropdown = ({ trigger, children, customClass }) => {
  const [open, setOpen] = useState(false);

  return (
    <Dropdown.Root
      open={open}
      onOpenChange={setOpen}
      className={`custom-dropdown-content ${customClass || ""}`}
    >
      <Dropdown.Trigger asChild>
        <div className={`custom-dropdown-trigger ${customClass || ""}`}>
          {trigger}
          <FaChevronDown />
        </div>
      </Dropdown.Trigger>

      <Dropdown.Portal
        className={`custom-dropdown-content ${customClass || ""}`}
      >
        <Dropdown.Content
          className={`custom-dropdown-content ${customClass || ""}`}
          side="bottom"
          align="start"
        >
          {typeof children === "function"
            ? children(() => setOpen(false))
            : React.cloneElement(children, {
                closeDropdown: () => setOpen(false),
              })}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
};

export default CustomDropdown;
